import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CalendarModule } from 'ion4-calendar';

import { MonthPickerComponent } from './month-picker.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    CalendarModule
  ],
  declarations: [
    MonthPickerComponent
  ],
  exports: [
    MonthPickerComponent
  ],
  entryComponents: [
    MonthPickerComponent
  ]
})
export class MonthPickerModule { }
